import { render, staticRenderFns } from "./form-green.vue?vue&type=template&id=19b7e89f&"
import script from "./form-green.vue?vue&type=script&lang=js&"
export * from "./form-green.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/base/form-green.vue
// module id = 34
// module chunks = 0